/**
 * Socket room for inbound email status changes. The API processing handlers announce every status
 * they write here; the Inbound Emails board listens and refetches, so rows move without a page refresh.
 */
import { SocketRoomEvent } from '../tenant.notification.payload';
import { RoomKey } from '../socket.room.key';
import { InboundEmailStatus } from '../../inbound.email/inbound.email.status';

export const InboundEmailEventType = {
    StatusChanged: 'status-changed',
} as const;

/** Which email changed and the status it now holds. */
export interface InboundEmailStatusChange {
    _id: string;
    status: InboundEmailStatus;
}

export type InboundEmailRoomMessage = SocketRoomEvent<typeof InboundEmailEventType.StatusChanged, InboundEmailStatusChange>;

export const InboundEmailRooms = {
    inboundEmails: (): RoomKey<InboundEmailRoomMessage> => ({ key: 'inbound-emails' }),
};
